import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Button, Theme, makeStyles } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    actionButton: {
        color: '#1899D4',
        fontSize: pxToRem(16),
        fontWeight: 500,
        marginBottom: 16,
        border: '1px solid #1899D4',
        borderRadius: pxToRem(50),
        background: 'transparent',
        boxShadow: 'none',
        '&:hover': {
            background: 'transparent',
            boxShadow: 'none',
        },
    },
}))

interface ImportDuplicateVersionDialogActionsProps {
    onOverrideVersion: () => void
    onCreateNewVersion: () => void
}

const ImportDuplicateVersionDialogActions: React.FC<ImportDuplicateVersionDialogActionsProps> = ({
    onOverrideVersion,
    onCreateNewVersion,
}) => {
    const classes = useStyles()

    return (
        <>
            <Button
                role="button"
                type="button"
                data-testid="overwriteButton"
                variant="contained"
                className={classes.actionButton}
                onClick={() => onOverrideVersion()}
                aria-label="Overwrite selected family versions"
            >
                Overwrite
            </Button>
            <Button
                role="button"
                type="button"
                data-testid="createNewVersionButton"
                variant="contained"
                className={classes.actionButton}
                onClick={() => onCreateNewVersion()}
                aria-label="Create new versions for selected families"
            >
                Create new version
            </Button>
        </>
    )
}

export default ImportDuplicateVersionDialogActions
